export const SHOW_FAQ = "SHOW_FAQ";
export const OPEN_FAQ_QUESTION = "OPEN_FAQ_QUESTION"
export const ADD_QUESTIONS = "ADD_QUESTIONS"
export const ADD_FEEDBACK_STATE = "ADD_FEEDBACK_STATE"
export const EXCELL_ACCESS = "EXCELL_ACCESS"
export const SHOW_CHAT = "SHOW_CHAT"
export const COOKIES = "COOKIES"
export const SHOW_RETURN_APPLICATION_MODAL = "SHOW_RETURN_APPLICATION_MODAL"
export const SHOW_PATCH_NOTES = "SHOW_PATCH_NOTES"
export const SET_READ_PATCHES = "SET_READ_PATCHES"